const useEventEmitter = () => {
  const events = {};
  const subscribeEvent = (eventName: string, callback: unknown) => {
    events[eventName] = callback;
  };
  const isAValidEvent = (eventName: string) => {
    return Boolean(events[eventName]);
  };
  const dispatchEvent = (eventName: string, data?: unknown) => {
    if (isAValidEvent(eventName)) {
      events[eventName](data);
    }
  };

  return {
    subscribeEvent,
    dispatchEvent,
    isAValidEvent,
  };
};

export default useEventEmitter;
